export const IRDAI_DOMAINS = [
  "Governance & Cyber Policy",
  "Risk Assessment & ISMS",
  "Policyholder Data Protection",
  "Identity & Access Management",
  "Security Monitoring & SOC",
  "Secure Software Development",
  "Vendor & TPA Risk Management",
  "Incident Response & Reporting",
  "Business Continuity & Disaster Recovery",
  "Awareness & Training",
];

export const IRDAI_CONTROLS = [
  {
    controlId: "IRDAI-GOV-01",
    domain: "Governance & Cyber Policy",
    requirement: "Board-approved IS Policy",
    insuranceContext: "Address policyholder data, agent/TPA access, digital channels",
    minimumBaseline: "Policy covering IRDAI areas, annual approval",
    evidence: "Policy, Board minutes",
    owner: "CISO",
    frequency: "Annual",
    technologyEnablers: "GRC Platform",
    testMethod: "Policy review",
    commonFindings: "Generic, not insurance-specific",
    severity: "High",
    automation: "Low",
  },
  {
    controlId: "IRDAI-GOV-02",
    domain: "Governance & Cyber Policy",
    requirement: "Designated ISO",
    insuranceContext: "Insurance domain expertise, Board reporting",
    minimumBaseline: "Senior appointment, quarterly reporting",
    evidence: "Appointment letter, Org chart",
    owner: "MD",
    frequency: "Ongoing",
    technologyEnablers: "-",
    testMethod: "Org review",
    commonFindings: "ISO too junior",
    severity: "High",
    automation: "Low",
  },
  {
    controlId: "IRDAI-DATA-01",
    domain: "Policyholder Data Protection",
    requirement: "PII encryption",
    insuranceContext: "All policyholder PII encrypted",
    minimumBaseline: "AES-256 at rest, TLS 1.2+ in transit",
    evidence: "Encryption config, Key mgmt",
    owner: "IT Head",
    frequency: "Continuous",
    technologyEnablers: "HSM, PKI, TDE",
    testMethod: "Technical review",
    commonFindings: "Partial encryption",
    severity: "Critical",
    automation: "High",
  },
  {
    controlId: "IRDAI-DATA-02",
    domain: "Policyholder Data Protection",
    requirement: "Consent management",
    insuranceContext: "Explicit consent for data collection/sharing",
    minimumBaseline: "Consent in digital channels, preference center",
    evidence: "Consent records",
    owner: "DPO",
    frequency: "Continuous",
    technologyEnablers: "Consent Platform",
    testMethod: "Consent audit",
    commonFindings: "Implicit consent assumed",
    severity: "High",
    automation: "Medium",
  },
  {
    controlId: "IRDAI-DATA-03",
    domain: "Policyholder Data Protection",
    requirement: "Data retention",
    insuranceContext: "Defined retention aligned to regulations",
    minimumBaseline: "Retention schedule, Secure disposal",
    evidence: "Retention policy, Certificates",
    owner: "Data Owner",
    frequency: "Annual",
    technologyEnablers: "Data Lifecycle",
    testMethod: "Retention audit",
    commonFindings: "Indefinite retention",
    severity: "Medium",
    automation: "Medium",
  },
  {
    controlId: "IRDAI-IAM-01",
    domain: "Identity & Access Management",
    requirement: "Agent/TPA access",
    insuranceContext: "Role-based access with activity logging",
    minimumBaseline: "Unique IDs, RBAC, logging, review",
    evidence: "Access matrix, Agent register",
    owner: "IAM Lead",
    frequency: "Quarterly",
    technologyEnablers: "IAM, Agent Portal",
    testMethod: "Access review",
    commonFindings: "Shared credentials",
    severity: "High",
    automation: "High",
  },
  {
    controlId: "IRDAI-IAM-02",
    domain: "Identity & Access Management",
    requirement: "Customer portal auth",
    insuranceContext: "Strong authentication for self-service",
    minimumBaseline: "MFA for sensitive transactions",
    evidence: "Portal config, MFA enrollment",
    owner: "App Owner",
    frequency: "Continuous",
    technologyEnablers: "MFA, SSO",
    testMethod: "Portal security test",
    commonFindings: "OTP-only MFA",
    severity: "High",
    automation: "High",
  },
  {
    controlId: "IRDAI-SOC-01",
    domain: "Security Monitoring & SOC",
    requirement: "Security monitoring",
    insuranceContext: "Monitor core systems and digital channels",
    minimumBaseline: "SIEM with insurance fraud, data theft use cases",
    evidence: "SOC architecture, Use cases",
    owner: "SOC Manager",
    frequency: "Continuous",
    technologyEnablers: "SIEM, SOAR",
    testMethod: "SOC review",
    commonFindings: "Generic use cases",
    severity: "High",
    automation: "High",
  },
  {
    controlId: "IRDAI-SDLC-01",
    domain: "Secure Software Development",
    requirement: "Secure development",
    insuranceContext: "Security in policy admin, claims, portals",
    minimumBaseline: "SAST/DAST, security requirements, threat modeling",
    evidence: "SDLC procedure, Tool reports",
    owner: "Dev Lead",
    frequency: "Per release",
    technologyEnablers: "SAST, DAST, SCA",
    testMethod: "SDLC audit",
    commonFindings: "No threat modeling",
    severity: "High",
    automation: "High",
  },
  {
    controlId: "IRDAI-VEN-01",
    domain: "Vendor & TPA Risk Management",
    requirement: "TPA security assessment",
    insuranceContext: "Assess all TPAs handling policyholder data",
    minimumBaseline: "Risk questionnaire, contractual requirements",
    evidence: "TPA assessments, Contracts",
    owner: "Vendor Manager",
    frequency: "Annual",
    technologyEnablers: "Vendor Risk",
    testMethod: "TPA audit",
    commonFindings: "No assessments",
    severity: "High",
    automation: "Medium",
  },
  {
    controlId: "IRDAI-VEN-02",
    domain: "Vendor & TPA Risk Management",
    requirement: "Reinsurer data sharing",
    insuranceContext: "Secure sharing with encryption and access controls",
    minimumBaseline: "Encrypted transfer, logging, minimization",
    evidence: "Transfer logs, Encryption",
    owner: "Underwriting",
    frequency: "Per transfer",
    technologyEnablers: "Secure Transfer",
    testMethod: "Transfer audit",
    commonFindings: "Unencrypted",
    severity: "High",
    automation: "Medium",
  },
  {
    controlId: "IRDAI-INC-01",
    domain: "Incident Response & Reporting",
    requirement: "Breach notification",
    insuranceContext: "Notify policyholders and IRDAI within timeline",
    minimumBaseline: "Template, 72-hour IRDAI reporting",
    evidence: "Notification procedure",
    owner: "CISO",
    frequency: "Per incident",
    technologyEnablers: "Incident Mgmt",
    testMethod: "IRP drill",
    commonFindings: "No procedure",
    severity: "Critical",
    automation: "Medium",
  },
  {
    controlId: "IRDAI-BCP-01",
    domain: "Business Continuity & Disaster Recovery",
    requirement: "Insurance ops continuity",
    insuranceContext: "BCP for underwriting, claims, customer service",
    minimumBaseline: "BIA, Recovery strategies, Annual testing",
    evidence: "BCP document, Test reports",
    owner: "BCP Lead",
    frequency: "Annual",
    technologyEnablers: "BCP Platform",
    testMethod: "BCP drill",
    commonFindings: "Generic BCP",
    severity: "High",
    automation: "Medium",
  },
  {
    controlId: "IRDAI-TRN-01",
    domain: "Awareness & Training",
    requirement: "Insurance security awareness",
    insuranceContext: "Training on fraud, social engineering, data handling",
    minimumBaseline: "Annual, Role-based, Completion tracking",
    evidence: "Training material, Reports",
    owner: "HR/CISO",
    frequency: "Annual",
    technologyEnablers: "LMS",
    testMethod: "Training audit",
    commonFindings: "Generic, low completion",
    severity: "Medium",
    automation: "High",
  },
];
